import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useCasesGeneralCallInfo } from './hook';
import { CasesGeneralProps } from './props';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';

export const CasesGeneralCallInfo = (props: CasesGeneralProps) => {
    const { formik, channels, branch, product, officie } =
        useCasesGeneralCallInfo(props);
    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información de la llamada
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={channels}
                    label="Canal"
                    name="channel"
                    size="small"
                    required
                    touched={formik.touched.channel}
                    errors={formik.errors.channel}
                    value={formik.values.channel as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Póliza"
                    name="policie"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.policie}
                    errors={formik.errors.policie}
                    value={formik.values.policie}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={product}
                    label="Producto"
                    name="product"
                    size="small"
                    required
                    touched={formik.touched.product}
                    errors={formik.errors.product}
                    value={formik.values.product as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={officie}
                    label="Oficina"
                    name="officie"
                    size="small"
                    required
                    touched={formik.touched.officie}
                    errors={formik.errors.officie}
                    value={formik.values.officie as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={branch}
                    label="Sucursal"
                    name="branch"
                    size="small"
                    required
                    touched={formik.touched.branch}
                    errors={formik.errors.branch}
                    value={formik.values.branch as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Placa"
                    name="plate"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.plate}
                    errors={formik.errors.plate}
                    value={formik.values.plate}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
